import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { Dropdown } from 'semantic-ui-react';
import ReactPaginate from 'react-paginate';
import Videos from '../../Videos/VideosList/Videos';
import * as action from '../../../actions/videos/trainingVideos';
import {
  DEFAULT_TYPE_OF_VIDEOS,
  DEFAULT_TYPE_OF_VIDEOS_KEYS,
} from '../../../constants/appConstants';
import {
  Wrapper,
  SpinnerContainer,
  Spinner,
} from '../../MenuGenerator/UserDetailBlock/StyleUserDetailBlock';
import SearchInput from '../../Common/SearchInput';
import FilteringByTagsBlock from '../../Common/FilteringByTagsBlock';
import { getTags } from '../../../actions/tags/getTags';
import TrainingLinks from '../TrainingLinks';
import GoToCreateButton from '../../UsersSubnavigation/GoToCreateButton';

const TrainingVideos = ({
  trainingVideosList,
  setTrainingVideo,
  isVideoModalOpen,
  setIsVideoModalOpen,
  setActiveVideo,
  isLoadingDelete,
  isDeleteModal,
  closeDeleteModal,
  openDeleteModal,
  deleteTrainingVideos,
  trainingVideosPageCount,
  trainingVideosCurrentPage,
  isTrainingVideosLoading,
  limberingUpVideosList,
  interruptionVideosList,
  selfDevelopmentVideosList,
  motivationVideosList,
  welcomeVideosList,
  faqVideosList,
  limberingUpVideosPageCount,
  limberingUpVideosCurrentPage,
  interruptionVideosPageCount,
  interruptionVideosCurrentPage,
  selfDevelopmentVideosPageCount,
  selfDevelopmentVideosCurrentPage,
  motivationVideosPageCount,
  motivationVideosCurrentPage,
  welcomeVideosPageCount,
  welcomeVideosCurrentPage,
  faqVideosPageCount,
  faqVideosCurrentPage,
  searchVideos,
  setChoosedVideosTags,
  videosTags,
  getTags,
  allVideoTags,
}) => {
  const [videosOptions, setVideosOptions] = useState({
    limbering_up: [],
    main_video: [],
    interruption: [],
    self_development: [],
    motivation: [],
    welcome: [],
    faq: [],
  });
  const [pagesValue, setPagesValue] = useState({
    main_video: { pageCount: 0, currentPage: 1 },
    limbering_up: { pageCount: 0, currentPage: 1 },
    interruption: { pageCount: 0, currentPage: 1 },
    self_development: { pageCount: 0, currentPage: 1 },
    motivation: { pageCount: 0, currentPage: 1 },
    welcome: { pageCount: 0, currentPage: 1 },
    faq: { pageCount: 0, currentPage: 1 },
  });
  const [videosOptionsValue, setVideosOptionsValue] = useState('main_video');
  const [isTagsOpened, setIsTagsOpened] = useState(false);
  const [searchValue, setSearchValue] = useState('');
  const [isTypeVideosChangeLoading, setIsTypeVideosChangeLoading] = useState(false);
  const handlePageClick = React.useCallback(
    (page) => {
      if (searchValue) {
        searchVideos(videosOptionsValue, searchValue, page.selected + 1, videosTags);
      } else {
        searchVideos(videosOptionsValue, '', page.selected + 1, videosTags);
      }
    },
    [searchVideos, searchValue, videosOptionsValue],
  );

  const setCurrentPagesValue = React.useCallback(() => {
    const newCurrentPagesValue = {};
    newCurrentPagesValue.main_video = {
      pageCount: trainingVideosPageCount,
      currentPage: trainingVideosCurrentPage,
    };
    newCurrentPagesValue.limbering_up = {
      pageCount: limberingUpVideosPageCount,
      currentPage: limberingUpVideosCurrentPage,
    };
    newCurrentPagesValue.interruption = {
      pageCount: interruptionVideosPageCount,
      currentPage: interruptionVideosCurrentPage,
    };
    newCurrentPagesValue.self_development = {
      pageCount: selfDevelopmentVideosPageCount,
      currentPage: selfDevelopmentVideosCurrentPage,
    };
    newCurrentPagesValue.motivation = {
      pageCount: motivationVideosPageCount,
      currentPage: motivationVideosCurrentPage,
    };
    newCurrentPagesValue.welcome = {
      pageCount: welcomeVideosPageCount,
      currentPage: welcomeVideosCurrentPage,
    };
    newCurrentPagesValue.faq = {
      pageCount: faqVideosPageCount,
      currentPage: faqVideosCurrentPage,
    };
    setPagesValue(newCurrentPagesValue);
  }, [
    trainingVideosPageCount,
    trainingVideosCurrentPage,
    limberingUpVideosPageCount,
    limberingUpVideosCurrentPage,
    interruptionVideosPageCount,
    interruptionVideosCurrentPage,
    selfDevelopmentVideosPageCount,
    selfDevelopmentVideosCurrentPage,
    motivationVideosPageCount,
    motivationVideosCurrentPage,
    welcomeVideosPageCount,
    welcomeVideosCurrentPage,
    faqVideosPageCount,
    faqVideosCurrentPage,
  ]);

  useEffect(() => {
    searchVideos(videosOptionsValue);
    getTags();
  }, []);

  useEffect(() => {
    const newVideosOptions = {};
    newVideosOptions.main_video = trainingVideosList;
    newVideosOptions.limbering_up = limberingUpVideosList;
    newVideosOptions.interruption = interruptionVideosList;
    newVideosOptions.self_development = selfDevelopmentVideosList;
    newVideosOptions.motivation = motivationVideosList;
    newVideosOptions.welcome = welcomeVideosList;
    newVideosOptions.faq = faqVideosList;
    setVideosOptions(newVideosOptions);
    setCurrentPagesValue();
  }, [
    trainingVideosList,
    limberingUpVideosList,
    interruptionVideosList,
    selfDevelopmentVideosList,
    motivationVideosList,
    welcomeVideosList,
    faqVideosList,
  ]);

  const onTypeChange = React.useCallback((e, data) => {
    setVideosOptionsValue(data.value);
    searchVideos(data.value);
    setIsTypeVideosChangeLoading(true);
  }, []);

  const searchVideosByTags = React.useCallback(
    (tags) => {
      searchVideos(videosOptionsValue, searchValue, 1, tags);
    },
    [videosOptionsValue, searchVideos],
  );

  const onCreateVideo = () => {
    setTrainingVideo([]);
  };

  if (isTypeVideosChangeLoading) {
    setIsTypeVideosChangeLoading(false);

    return (
      <Wrapper>
        <SpinnerContainer>
          <Spinner />
        </SpinnerContainer>
      </Wrapper>
    );
  }
  const vidoesOptions = DEFAULT_TYPE_OF_VIDEOS.map((videoName, i) => {
    return { key: videoName, text: videoName, value: DEFAULT_TYPE_OF_VIDEOS_KEYS[i] };
  });

  return (
    <TrainingContainer>
      <TrainingLinks title="Видео тренировок" />
      <DropdownBlock>
        <Dropdown
          placeholder="Выберите тип тренировки"
          fluid
          selection
          onChange={(e, data) => onTypeChange(e, data)}
          defaultValue={videosOptionsValue}
          options={vidoesOptions}
        />
      </DropdownBlock>
      <SearchInput
        placeholder="Поиск видео"
        getSearchItem={searchVideos}
        type={videosOptionsValue}
        choosedTagsIds={videosTags}
        setSearchValue={setSearchValue}
      />
      <FilteringByTagsBlock
        getList={searchVideosByTags}
        savedChoosedTags={videosTags}
        setChoosedTagsToStore={setChoosedVideosTags}
        tags={allVideoTags}
        setIsOpened={setIsTagsOpened}
        isOpened={isTagsOpened}
        applyButtonText="Фильтровать видео"
        collapseTitleText="Фильтровать видео"
      />
      <Videos
        videosList={videosOptions[videosOptionsValue]}
        setTrainingVideo={setTrainingVideo}
        isVideoModalOpen={isVideoModalOpen}
        setIsVideoModalOpen={setIsVideoModalOpen}
        setActiveVideo={setActiveVideo}
        isLoadingDelete={isLoadingDelete}
        isDeleteModal={isDeleteModal}
        openDeleteModal={openDeleteModal}
        closeDeleteModal={closeDeleteModal}
        deleteVideos={deleteTrainingVideos}
        isTrainingVideosLoading={isTrainingVideosLoading}
      />
      <ReactPaginate
        previousLabel="<"
        nextLabel=">"
        breakLabel="..."
        pageCount={pagesValue[videosOptionsValue].pageCount}
        marginPagesDisplayed={3}
        pageRangeDisplayed={3}
        onPageChange={handlePageClick}
        previousLinkClassName="prev-page-btn"
        nextLinkClassName="next-page-btn"
        containerClassName="pagination"
        activeLinkClassName="active-page-btn"
        pageLinkClassName="page-btn"
        breakClassName="break-me"
        background="white"
      />
      <PlusButton onClick={onCreateVideo}>
        <GoToCreateButton link="/changeTrainingVideos" />
      </PlusButton>
    </TrainingContainer>
  );
};

const mapStateToProps = (state) => {
  const {
    trainingVideosList,
    isVideoModalOpen,
    isLoadingDelete,
    isDeleteModal,
    trainingVideosPageCount,
    trainingVideosCurrentPage,
    isTrainingVideosLoading,
    limberingUpVideosList,
    interruptionVideosList,
    selfDevelopmentVideosList,
    motivationVideosList,
    welcomeVideosList,
    faqVideosList,
    limberingUpVideosPageCount,
    limberingUpVideosCurrentPage,
    interruptionVideosPageCount,
    interruptionVideosCurrentPage,
    selfDevelopmentVideosPageCount,
    selfDevelopmentVideosCurrentPage,
    motivationVideosPageCount,
    motivationVideosCurrentPage,
    welcomeVideosPageCount,
    welcomeVideosCurrentPage,
    faqVideosPageCount,
    faqVideosCurrentPage,
    videosTags,
  } = state.trainingVideos;
  const { allVideoTags } = state.getTags;

  return {
    trainingVideosList,
    isVideoModalOpen,
    isLoadingDelete,
    isDeleteModal,
    trainingVideosPageCount,
    trainingVideosCurrentPage,
    isTrainingVideosLoading,
    limberingUpVideosList,
    interruptionVideosList,
    selfDevelopmentVideosList,
    motivationVideosList,
    welcomeVideosList,
    faqVideosList,
    limberingUpVideosPageCount,
    limberingUpVideosCurrentPage,
    interruptionVideosPageCount,
    interruptionVideosCurrentPage,
    selfDevelopmentVideosPageCount,
    selfDevelopmentVideosCurrentPage,
    motivationVideosPageCount,
    motivationVideosCurrentPage,
    welcomeVideosPageCount,
    welcomeVideosCurrentPage,
    faqVideosPageCount,
    faqVideosCurrentPage,
    videosTags,
    allVideoTags,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setTrainingVideo: (trainingVideo) => {
      dispatch(action.setTrainingVideo(trainingVideo));
    },
    setIsVideoModalOpen: (isOpen) => {
      // !!
      dispatch(action.setIsVideoModalOpen(isOpen));
    },
    setActiveVideo: (activeVideo) => {
      // !!
      dispatch(action.setActiveVideo(activeVideo));
    },
    openDeleteModal: () => {
      dispatch(action.openDeleteModal());
    },
    closeDeleteModal: () => {
      dispatch(action.closeDeleteModal());
    },
    deleteTrainingVideos: (productId) => {
      dispatch(action.deleteTrainingVideos(productId));
    },
    searchVideos: (type, name, page, tags) => {
      dispatch(action.searchVideos(type, name, page, tags));
    },
    setChoosedVideosTags: (tags) => {
      dispatch(action.setChoosedVideosTags(tags));
    },
    getTags: () => {
      dispatch(getTags());
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TrainingVideos);

const TrainingContainer = styled.div`
  width: 70%;
  margin: 0 auto 10px auto;
  @media (max-width: 992px) {
    width: 80%;
  }
`;
const DropdownBlock = styled.div`
  margin: 10px 0;
`;

const PlusButton = styled.button`
  position: fixed;
  width: 80px;
  height: 80px;
  right: 25px;
  bottom: 25px;
  cursor: pointer;
  box-sizing: border-box;
  display: flex;
  text-align: center;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  background: #5da834;
  color: #fff;
  border-radius: 50%;
  border: 2px solid #000542;
  &:hover {
    background: #1b8100;
  }
  @media (max-width: 768px) {
    width: 60px;
    height: 60px;
  }
  @media (max-width: 500px) {
    right: 15px;
  }
`;



// WEBPACK FOOTER //
// ./src/Components/Training/TrainingList/TrainingVideos.jsx